import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { TemplateDto, TemplateUpsertBody } from "./templateDtos";

// POST /v2/support/treatments/schedules — creates a standardized (library) template.
export const useCreateTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: TemplateUpsertBody): Promise<TemplateDto> => {
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      const created: TemplateDto = await api.parse(`POST /treatments/schedules`, {
        root: supportApiBase,
        data: body,
      });
      return created;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.templates());
      },
    }
  );
};
